export default __webpack_public_path__ + "static/media/Izmir-Bold.ac7fb252.woff2";